import { createContext, PropsWithChildren, useContext, useState } from 'react';
import localisationsHu from '../assets/translations/hu.json';

const useAppProviderService = () => {
    const [language, setLanguage] = useState<string>('hu');
    const [localisations] = useState<Record<string, string>>(localisationsHu);

    return {
        language,
        setLanguage,
        localisations,
    };
};

export const AppContext = createContext<ReturnType<typeof useAppProviderService>>({
    setLanguage: () => {},
    language: 'hu',
    localisations: {},
});

export const AppProvider = ({ children }: PropsWithChildren<{}>) => {
    const providerValue = useAppProviderService();

    return <AppContext.Provider value={providerValue}>{children}</AppContext.Provider>;
};

export const useApp = () => useContext(AppContext);
